/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import { useHistory } from 'react-router-dom';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textTransform: 'capitalize',
  },
}));

export const signalTypesOptions = [
  {
    value: 'tv_strategy',
    label: 'Pinescript',
  },
  {
    value: 'tv_indicator',
    label: 'Indicator',
  },
];

const CellType = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const history = useHistory();

  const type = useSelector((state) => {
    const { type = '' } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return type;
  });

  const formattedType =
    signalTypesOptions.find((item) => item.value === type)?.label || type;

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      {formattedType}
    </div>
  );
};

export default CellType;
